require('./brokerStocksSellSuccess.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL
} = require('constants/index');
const {catalogue, analyticsId} = require('components/broker/brokerStocksSell/analytics/brokerStockSell.tracking');

// @utils
const { recordLinkV2 } = require("utilities/tagging");

const BrokerStocksSellSuccess = props => {
    const { companyName, immStocksSell, immStocksContracts, productFile, isin } = props;
    const mockedOrderNumber = immStocksSell.get('orderNumber');
    const successMessage = formatText('broker-stocksSellSuccessStepMessage');
    const successSubMessage = formatText('broker-stocksSellSuccessStepSubMessage', [mockedOrderNumber]);
    const mainButtonLabel = formatText('broker-stocksSellSuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText('broker-stocksSellSuccessStepReviewOrdersButtonLabel');
    const step1 = immStocksSell.get('steps').get(FIRST_STEP);
    const step2 = immStocksSell.get('steps').get(SECOND_STEP);
    const selectedOptionValue = step1.get('selectedOptionValue');
    const stockContract = immStocksContracts.find(contract => {
        return contract.get('contactNumber') === selectedOptionValue;
    });
    const productCurrency = productFile.get('currency');

    if (!stockContract) {
        return;
    }

    React.useEffect(() => {
        recordLinkV2(catalogue[analyticsId.BROKER_STOCK_SELL_STEP_2_SUCCESS]());
    }, []);

    return (
        <WizardSuccess
            successMessage={successMessage}
            successSubMessage={successSubMessage}
            customClassName="stocks-sell-success"
            mainButton={{label: mainButtonLabel, url: MYPROFILE_BROKER_URL, modifier: 'secondary'}}
            secondaryButton={{label:secondaryButtonLabel, url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL}}
            tealium={catalogue[analyticsId.BROKER_STOCK_SELL_SUCCESS]({ productName: isin })}
            isSecondVersion
        >
            <div>
                <h2 className="stocks-sell-success__summary-header">
                    {formatText('broker-stocksSellSuccessStepSubtitle')}
                </h2>
                <StocksBuySellSummary
                    productName={formatText('broker-stockProductName')}
                    productCurrency={productCurrency}
                    stockContract={stockContract}
                    stockDescription={companyName}
                    step1={step1}
                    step2={step2}
                    modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
                    productIso={productFile.get('micCode')}
                />
            </div>
        </WizardSuccess>
    );
};

BrokerStocksSellSuccess.propTypes = {
    productFile: PropTypes.object.isRequired,
    immStocksSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    companyName: PropTypes.string.isRequired,
    isin: PropTypes.string.isRequired,
};

module.exports = BrokerStocksSellSuccess;
